import React from 'react';
import Link from './Link';
import Image from './Image';

const placeholderImg = 'avatar-awaiting.png';

export default function Avatar({
  avatar,
  alt,
  linkTo,
  linkTitle,
  className,
  track,
}) {
  const avatarImg =
    (<Image
      className={className}
      src={avatar || placeholderImg}
      external={avatar}
      alt={alt}
    />);

  if (linkTo) {
    return (
      <Link
        title={linkTitle}
        to={linkTo}
        track={track}
        external
        className={className}
      >
        {avatarImg}
      </Link>
    );
  }

  return avatarImg;
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/Avatar.js